// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__1v_6o","Icon":"Languages_Icon__7n1mO","LanguagesSelect":"Languages_LanguagesSelect__1HpEp","minimalist":"Languages_minimalist__XC94p"};